(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* Cart page quantity steppers + AJAX updates */
  (function () {
    var section = document.querySelector('[data-cart-section]');
    if (!section) return;

    /* Quantity +/- buttons */
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
      if (!btn) return;

      var wrap = btn.closest('.cart-item__qty-wrap');
      if (!wrap) return;

      var input = wrap.querySelector('[data-qty-input]');
      if (!input) return;

      var val = parseInt(input.value, 10) || 1;

      if (btn.hasAttribute('data-qty-minus')) {
        input.value = Math.max(0, val - 1);
      } else {
        input.value = Math.min(99, val + 1);
      }

      /* Auto-update via AJAX after a short debounce */
      clearTimeout(input._debounce);
      input._debounce = setTimeout(function () {
        updateCart();
      }, 500);
    });

    /* Also update on manual input change */
    section.addEventListener('change', function (e) {
      if (e.target.matches('[data-qty-input]')) {
        updateCart();
      }
    });

    /* Remove links via AJAX */
    section.addEventListener('click', function (e) {
      var removeLink = e.target.closest('[data-cart-remove]');
      if (!removeLink) return;

      e.preventDefault();

      var item = removeLink.closest('[data-cart-item]');
      var line = item ? parseInt(item.dataset.line, 10) : null;
      if (line === null) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          updateBadge(cart);
          location.reload();
        })
        .catch(function () {
          location.reload();
        });
    });

    function updateCart() {
      var form = section.querySelector('[data-cart-form]');
      if (!form) return;

      var inputs = form.querySelectorAll('[data-qty-input]');
      var updates = [];
      inputs.forEach(function (inp) {
        updates.push(parseInt(inp.value, 10) || 0);
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          updateBadge(cart);
          /* Reload to get fresh HTML - simplest approach for server-rendered cart */
          location.reload();
        })
        .catch(function () {
          location.reload();
        });
    }

    function updateBadge(cart) {
      var badge = document.querySelector('.site-header__cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count } }));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"] && !Shopify.designMode) return;
  try {
    
  /* Tag filtering via radio buttons.
     A small script listens for radio changes and toggles card visibility
     since static stylesheets can't have dynamic selectors for unknown tag names. */
  (function () {
    const section = document.querySelector('.col-products__toggle');
    if (!section) return;

    const radios = section.querySelectorAll('.col-products__radio');
    const cards = section.querySelectorAll('.col-product-card');

    function filterCards() {
      const selected = section.querySelector('.col-products__radio:checked');
      if (!selected) return;

      const value = selected.value;

      cards.forEach(function (card) {
        if (value === 'all') {
          card.classList.remove('is-hidden');
        } else {
          const hasTag = card.hasAttribute('data-tag-' + value);
          card.classList.toggle('is-hidden', !hasTag);
        }
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', filterCards);
    });

    /* Run once on load in case a filter is pre-selected */
    filterCards();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.product-hero-section[data-section-id]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      if (section.dataset.productHeroBound === 'true') return;
      section.dataset.productHeroBound = 'true';

      var gallery = section.querySelector('[data-gallery]');
      var viewer = section.querySelector('[data-gallery-viewer]');
      var thumbs = section.querySelectorAll('[data-thumb]');
      var hideOtherVariantMediaEnabled = gallery ? gallery.dataset.hideOtherVariantMedia === 'true' : false;
      var currentImg = viewer ? viewer.querySelector('[data-gallery-img]') : null;
      var defaultImage = {
        src: currentImg ? currentImg.dataset.defaultSrc || currentImg.getAttribute('src') || '' : '',
        fullSrc: currentImg ? currentImg.dataset.defaultFullSrc || currentImg.dataset.fullSrc || currentImg.getAttribute('src') || '' : '',
        alt: currentImg ? currentImg.dataset.defaultAlt || currentImg.getAttribute('alt') || '' : '',
      };

      function parseVariantIds(value) {
        if (!value) return [];
        return value
          .split(',')
          .map(function (id) {
            return parseInt(id, 10);
          })
          .filter(function (id) {
            return !Number.isNaN(id);
          });
      }

      /* ── Slide list for lightbox ── */
      var slides = [];
      thumbs.forEach(function (t) {
        var mediaId = parseInt(t.dataset.mediaId, 10);
        var variantIds = parseVariantIds(t.dataset.variantIds);
        slides.push({
          type: t.dataset.type || 'image',
          src: t.dataset.src || '',
          fullSrc: t.dataset.fullSrc || '',
          alt: t.dataset.alt || '',
          videoUrl: t.dataset.videoUrl || '',
          poster: t.dataset.poster || '',
          fullPoster: t.dataset.fullPoster || '',
          mediaId: Number.isNaN(mediaId) ? null : mediaId,
          variantIds: variantIds,
          attachedToVariant: t.dataset.attachedToVariant === 'true',
          element: t,
          isHidden: false,
        });
      });

      var activeIndex = 0;
      var activeThumb = section.querySelector('[data-thumb].is-active');
      if (activeThumb) {
        thumbs.forEach(function (thumb, idx) {
          if (thumb === activeThumb) {
            activeIndex = idx;
          }
        });
      }

      function clearViewerVideo() {
        if (!viewer) return;
        var oldVid = viewer.querySelector('.product-hero__video, .product-hero__video-iframe');
        if (oldVid) oldVid.remove();
      }

      function clearActiveThumbs() {
        thumbs.forEach(function (thumb) {
          thumb.classList.remove('is-active');
        });
      }

      function isSlideVisible(slide) {
        return slide && slide.isHidden !== true;
      }

      function setSlideVisibility(slide, isVisible) {
        if (!slide || !slide.element) return;
        slide.isHidden = !isVisible;
        slide.element.classList.toggle('is-hidden', !isVisible);
        slide.element.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        if (isVisible) {
          slide.element.removeAttribute('hidden');
          slide.element.removeAttribute('tabindex');
        } else {
          slide.element.setAttribute('hidden', 'hidden');
          slide.element.setAttribute('tabindex', '-1');
          slide.element.classList.remove('is-active');
        }
      }

      function getFirstVisibleSlideIndex() {
        for (var i = 0; i < slides.length; i++) {
          if (isSlideVisible(slides[i])) return i;
        }
        return -1;
      }

      function findVariantMediaSlideIndex(variant, onlyVisible) {
        if (!variant) return -1;
        var matchIndex = -1;

        if (variant.featured_media_id) {
          slides.forEach(function (slide, idx) {
            if (matchIndex !== -1) return;
            if (onlyVisible && !isSlideVisible(slide)) return;
            if (slide.mediaId === variant.featured_media_id) {
              matchIndex = idx;
            }
          });
        }

        if (matchIndex === -1 && variant.featured_image_src) {
          slides.forEach(function (slide, idx) {
            if (matchIndex !== -1) return;
            if (onlyVisible && !isSlideVisible(slide)) return;
            if (slide.type !== 'image') return;
            if (slide.src === variant.featured_image_src) {
              matchIndex = idx;
              return;
            }
            if (variant.featured_image_full_src && slide.fullSrc === variant.featured_image_full_src) {
              matchIndex = idx;
            }
          });
        }

        if (matchIndex === -1 && variant.id) {
          var selectedVariantId = parseInt(variant.id, 10);
          if (!Number.isNaN(selectedVariantId)) {
            slides.forEach(function (slide, idx) {
              if (matchIndex !== -1) return;
              if (onlyVisible && !isSlideVisible(slide)) return;
              if (!slide.variantIds || slide.variantIds.length === 0) return;
              if (slide.variantIds.indexOf(selectedVariantId) > -1) {
                matchIndex = idx;
              }
            });
          }
        }

        return matchIndex;
      }

      function showImage(src, fullSrc, alt) {
        if (!viewer || !currentImg || !src) return;
        clearViewerVideo();
        currentImg.style.display = '';
        currentImg.classList.add('is-fading');
        setTimeout(function () {
          currentImg.alt = alt || '';
          currentImg.dataset.fullSrc = fullSrc || src;
          function onReady() {
            currentImg.onload = null;
            currentImg.onerror = null;
            currentImg.classList.remove('is-fading');
          }
          currentImg.onload = onReady;
          currentImg.onerror = onReady;
          currentImg.src = src;
          if (currentImg.complete && currentImg.naturalWidth) {
            onReady();
          }
        }, 200);
        viewer.style.cursor = 'zoom-in';
      }

      /* ── Swap viewer content ── */
      function showSlide(idx) {
        if (!viewer) return;
        if (idx < 0 || idx >= slides.length) return;
        if (!isSlideVisible(slides[idx])) return;
        activeIndex = idx;
        var slide = slides[idx];
        clearActiveThumbs();
        thumbs.forEach(function (thumb, i) {
          if (i === idx) thumb.classList.add('is-active');
        });
        clearViewerVideo();

        if (slide.type === 'image') {
          showImage(slide.src, slide.fullSrc || slide.src, slide.alt);
        } else if (slide.type === 'hosted') {
          /* Self-hosted / asset video, autoplay no controls */
          if (currentImg) currentImg.style.display = 'none';
          var vid = document.createElement('video');
          vid.className = 'product-hero__video';
          vid.src = slide.videoUrl;
          vid.autoplay = true;
          vid.loop = true;
          vid.muted = true;
          vid.playsInline = true;
          vid.setAttribute('playsinline', '');
          vid.setAttribute('disablepictureinpicture', '');
          vid.controls = false;
          if (slide.poster) vid.poster = slide.poster;
          viewer.appendChild(vid);
          viewer.style.cursor = 'default';
        } else if (slide.type === 'youtube') {
          /* YouTube embed, autoplay */
          if (currentImg) currentImg.style.display = 'none';
          var url = slide.videoUrl;
          /* Ensure embed format */
          if (url.indexOf('watch?v=') > -1) {
            url = url.replace('watch?v=', 'embed/');
            url = url.replace(/&.*$/, '');
          }
          if (url.indexOf('youtu.be/') > -1) {
            url = url.replace('youtu.be/', 'www.youtube.com/embed/');
          }
          /* Add autoplay params */
          var sep = url.indexOf('?') > -1 ? '&' : '?';
          url += sep + 'autoplay=1&mute=1&controls=0&modestbranding=1&rel=0&loop=1&playsinline=1';
          var iframe = document.createElement('iframe');
          iframe.className = 'product-hero__video-iframe';
          iframe.src = url;
          iframe.allow = 'autoplay; encrypted-media';
          iframe.allowFullscreen = false;
          iframe.loading = 'lazy';
          viewer.appendChild(iframe);
          viewer.style.cursor = 'default';
        }
      }

      /* ── Thumbnail clicks ── */
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          showSlide(i);
        });
      });

      /* ── Lightbox ── */
      var lightbox = section.querySelector('[data-lightbox]');
      var lbImg = section.querySelector('[data-lightbox-img]');
      var lbContent = section.querySelector('[data-lightbox-content]');
      var lbCounter = section.querySelector('[data-lightbox-counter]');
      var lbCloses = section.querySelectorAll('[data-lightbox-close]');
      var lbPrev = section.querySelector('[data-lightbox-prev]');
      var lbNext = section.querySelector('[data-lightbox-next]');
      var lbIndex = 0;
      var imageSlides = [];

      function rebuildImageSlides() {
        imageSlides = [];
        slides.forEach(function (slide, idx) {
          if (slide.type === 'image' && isSlideVisible(slide)) {
            imageSlides.push({ idx: idx, src: slide.fullSrc || slide.src, alt: slide.alt });
          }
        });
      }

      rebuildImageSlides();

      function openLightbox(imgIdx) {
        if (!lightbox || !lbImg || imageSlides.length === 0) return;
        lbIndex = imgIdx;
        showLightboxSlide();
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeLightbox() {
        if (!lightbox) return;
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      function showLightboxSlide() {
        if (!lbImg || imageSlides.length === 0) return;
        var s = imageSlides[lbIndex];
        lbImg.classList.add('is-loading');
        lbImg.onload = function () {
          lbImg.classList.remove('is-loading');
        };
        lbImg.src = s.src;
        lbImg.alt = s.alt;
        if (lbCounter) lbCounter.textContent = lbIndex + 1 + ' / ' + imageSlides.length;
      }

      /* Open lightbox on viewer click (image slides only) */
      if (viewer) {
        viewer.addEventListener('click', function () {
          var slide = slides[activeIndex];
          if (!slide || slide.type !== 'image') return;
          /* Find this in image slides */
          for (var i = 0; i < imageSlides.length; i++) {
            if (imageSlides[i].idx === activeIndex) {
              openLightbox(i);
              break;
            }
          }
        });
      }

      lbCloses.forEach(function (btn) {
        btn.addEventListener('click', closeLightbox);
      });

      if (lbPrev)
        lbPrev.addEventListener('click', function () {
          lbIndex = (lbIndex - 1 + imageSlides.length) % imageSlides.length;
          showLightboxSlide();
        });

      if (lbNext)
        lbNext.addEventListener('click', function () {
          lbIndex = (lbIndex + 1) % imageSlides.length;
          showLightboxSlide();
        });

      document.addEventListener('keydown', function (e) {
        if (!lightbox || !lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft' && lbPrev) lbPrev.click();
        if (e.key === 'ArrowRight' && lbNext) lbNext.click();
      });

      /* ── Swipe support for lightbox on mobile ── */
      (function () {
        if (!lbContent) return;
        var startX = 0;
        lbContent.addEventListener(
          'touchstart',
          function (e) {
            startX = e.touches[0].clientX;
          },
          { passive: true }
        );
        lbContent.addEventListener(
          'touchend',
          function (e) {
            var diff = e.changedTouches[0].clientX - startX;
            if (Math.abs(diff) > 50) {
              if (diff < 0 && lbNext) lbNext.click();
              else if (diff > 0 && lbPrev) lbPrev.click();
            }
          },
          { passive: true }
        );
      })();

      /* ── Quantity +/- ── */
      var qtyWrap = section.querySelector('.product-hero__qty-wrap');
      if (qtyWrap) {
        var input = qtyWrap.querySelector('[data-qty-input]');
        var minus = qtyWrap.querySelector('[data-qty-minus]');
        var plus = qtyWrap.querySelector('[data-qty-plus]');
        if (minus && input)
          minus.addEventListener('click', function () {
            var v = parseInt(input.value, 10) || 1;
            input.value = Math.max(1, v - 1);
          });
        if (plus && input)
          plus.addEventListener('click', function () {
            var v = parseInt(input.value, 10) || 1;
            input.value = Math.min(99, v + 1);
          });
      }

      /* ── Variant switching ── */
      var selects = section.querySelectorAll('.product-hero__select');
      var variantInput = section.querySelector('[data-variant-id]');
      var priceEl = section.querySelector('[data-product-price]');
      var btn = section.querySelector('[data-add-to-cart]');
      var productJson = null;

      function findVariantById(variantId) {
        if (!productJson || !productJson.variants) return null;
        return (
          productJson.variants.find(function (variant) {
            return variant.id === variantId;
          }) || null
        );
      }

      function findVariantByOptions(options) {
        if (!productJson || !productJson.variants) return null;
        return (
          productJson.variants.find(function (variant) {
            return variant.options.every(function (optionValue, idx) {
              return optionValue === options[idx];
            });
          }) || null
        );
      }

      function getSelectedOptions() {
        var options = [];
        selects.forEach(function (select) {
          options.push(select.value);
        });
        return options;
      }

      function setSelectsFromVariant(variant) {
        if (!variant || !variant.options) return;
        selects.forEach(function (select, idx) {
          if (variant.options[idx] !== undefined) {
            select.value = variant.options[idx];
          }
        });
      }

      function syncVariantUrl(variantId) {
        if (!variantId || !window.history.replaceState) return;
        var nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', String(variantId));
        window.history.replaceState({}, '', nextUrl.pathname + nextUrl.search + nextUrl.hash);
      }

      function revealViewerOnVariantChange() {
        if (!viewer) return;

        var viewerRect = viewer.getBoundingClientRect();
        var rootStyles = getComputedStyle(document.documentElement);
        var rawHeaderOffset = rootStyles.getPropertyValue('--header-h') || '0';
        var headerOffset = parseFloat(rawHeaderOffset);
        if (Number.isNaN(headerOffset)) headerOffset = 0;

        var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        if (isDesktop) {
          var minVisibleTop = headerOffset + 8;
          var isViewerVisible = viewerRect.top >= minVisibleTop && viewerRect.bottom <= window.innerHeight;
          if (isViewerVisible) return;
        }

        var targetTop = window.scrollY + viewerRect.top - headerOffset - 16;
        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: 'smooth',
        });
      }

      function showAllMediaSlides() {
        slides.forEach(function (slide) {
          setSlideVisibility(slide, true);
        });
        rebuildImageSlides();
      }

      function applyMediaFiltering(variant) {
        if (!hideOtherVariantMediaEnabled || !variant || !variant.id) {
          showAllMediaSlides();
          return;
        }

        var targetIndex = findVariantMediaSlideIndex(variant, false);

        slides.forEach(function (slide, idx) {
          if (slide.type !== 'image') {
            setSlideVisibility(slide, true);
            return;
          }

          var hasVariantAssociation =
            slide.attachedToVariant || (slide.variantIds && slide.variantIds.length > 0);

          if (hasVariantAssociation) {
            if (targetIndex > -1) {
              setSlideVisibility(slide, idx === targetIndex);
            } else {
              setSlideVisibility(slide, false);
            }
            return;
          }

          setSlideVisibility(slide, true);
        });

        if (getFirstVisibleSlideIndex() === -1) {
          showAllMediaSlides();
          return;
        }

        var needsFallbackSelection = false;
        if (activeIndex >= 0) {
          needsFallbackSelection = activeIndex >= slides.length || !isSlideVisible(slides[activeIndex]);
        } else if (!variant.featured_image_src) {
          needsFallbackSelection = true;
        }

        if (needsFallbackSelection) {
          targetIndex = findVariantMediaSlideIndex(variant, true);
          if (targetIndex === -1) {
            targetIndex = getFirstVisibleSlideIndex();
          }
          if (targetIndex > -1) {
            showSlide(targetIndex);
          }
        }

        rebuildImageSlides();
      }

      function renderVariantMedia(variant) {
        if (!variant) return;

        var mediaSlideIndex = findVariantMediaSlideIndex(variant, false);
        if (mediaSlideIndex > -1) {
          showSlide(mediaSlideIndex);
          return;
        }

        if (variant.featured_image_src) {
          clearActiveThumbs();
          activeIndex = -1;
          showImage(
            variant.featured_image_src,
            variant.featured_image_full_src || variant.featured_image_src,
            variant.featured_image_alt || ''
          );
          return;
        }

        if (defaultImage.src) {
          clearActiveThumbs();
          activeIndex = -1;
          showImage(defaultImage.src, defaultImage.fullSrc || defaultImage.src, defaultImage.alt || '');
        }
      }

      function applyVariant(variant, shouldSyncUrl, shouldRevealViewer) {
        if (!variant) return;
        if (variantInput) {
          variantInput.value = variant.id;
        }

        if (priceEl) {
          priceEl.textContent = Shopify.formatMoney
            ? Shopify.formatMoney(variant.price)
            : '$' + (variant.price / 100).toFixed(2);
        }

        if (btn) {
          btn.disabled = !variant.available;
          btn.textContent = variant.available
            ? btn.dataset.addText || 'Add to cart'
            : btn.dataset.soldText || 'Sold out';
        }

        applyMediaFiltering(variant);
        renderVariantMedia(variant);

        if (shouldRevealViewer) {
          revealViewerOnVariantChange();
        }

        if (shouldSyncUrl) {
          syncVariantUrl(variant.id);
        }
      }

      if (variantInput) {
        var scriptEl = section.querySelector('[data-product-json]');
        if (scriptEl) {
          try {
            productJson = JSON.parse(scriptEl.textContent);
          } catch (e) {}
        }
      }

      if (productJson && productJson.variants && productJson.variants.length) {
        var initialVariant = null;
        var urlVariantId = parseInt(new URLSearchParams(window.location.search).get('variant'), 10);
        var variantFromUrl = null;

        if (!Number.isNaN(urlVariantId)) {
          variantFromUrl = findVariantById(urlVariantId);
          if (variantFromUrl) {
            initialVariant = variantFromUrl;
          }
        }

        if (!initialVariant && selects.length) {
          initialVariant = findVariantByOptions(getSelectedOptions());
        }

        if (!initialVariant && variantInput) {
          var inputVariantId = parseInt(variantInput.value, 10);
          if (!Number.isNaN(inputVariantId)) {
            initialVariant = findVariantById(inputVariantId);
          }
        }

        if (!initialVariant) {
          initialVariant = productJson.variants[0];
        }

        if (initialVariant) {
          setSelectsFromVariant(initialVariant);
          applyVariant(initialVariant, false, false);
        }

        selects.forEach(function (select) {
          select.addEventListener('change', function () {
            var match = findVariantByOptions(getSelectedOptions());
            if (match) {
              applyVariant(match, true, true);
            }
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
